// Export principal du service billing
import { LemonSqueezyService } from "../billing/LemonSqueezyService";
const billingService = new LemonSqueezyService();
export { billingService };
export { SubscriptionViewModelMapper } from "./SubscriptionViewModel";
export * from "./types";

// Types pour l'intégration future avec le vrai backend
export interface BillingServiceConfig {
  apiKey?: string;
  baseUrl?: string;
  environment?: "development" | "staging" | "production";
}

// Factory pour créer le service approprié selon l'environnement
export function createBillingService(config: BillingServiceConfig = {}) {
  return billingService; // LemonSqueezyService pour tous les environnements
}
